import { h, Component } from 'preact';
import Border from '../border/border';
import Content from '../content/content';
import ContactForm from '../contactForm/contactForm';
import styles from './contact.css';

export default class Contact extends Component {
  render() {
    return (<div className={styles.container} id="page-contact">
      <Content className={`flex ${styles.content}`}>
        <div className={styles.textContainer}>
          <h2>Contact Us</h2>
          <p>We are a pretty easy going bunch and are happy to help customise the right solution for you. This could be anything from providing staff to pour the drink, working with select artists for label creation, through to hosting master brewing tasting sessions. Just drop us a line and we can help you out.</p>
        </div>
        <div className={`${styles.contactFormContainer} handDrawn`}>
          <img src="/assets/text-hello-there.png" className={styles.helloText} />
          <img src="/assets/text-call-us.png" className={styles.callUsText} />
          <ContactForm />
        </div>
      </Content>
      <Border color="black" />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/contact/contact.jsx